import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> { error?: string; }
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> { error?: string; }

export function Input({error,className='',ref:_,...props}:InputProps&{ref?:any}){
  return(
    <div>
      <input className={`input ${error?'border-red-300 focus:ring-red-500':''} ${className}`} {...props}/>
      {error&&<p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
}

export function Select({error,className='',children,...props}:SelectProps){
  return(
    <div>
      <select className={`input ${error?'border-red-300 focus:ring-red-500':''} ${className}`} {...props}>{children}</select>
      {error&&<p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
}

export function Textarea({error,className='',...props}:React.TextareaHTMLAttributes<HTMLTextAreaElement>&{error?:string}){
  return(
    <div>
      <textarea className={`input resize-none ${error?'border-red-300 focus:ring-red-500':''} ${className}`} {...props}/>
      {error&&<p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
}
